import React from 'react';

export function useWarnOnLeave(
  message = 'Om du lämnar sidan kommer du att förlora alla dina formulärförlopp, är du säker?',
) {
  React.useEffect(() => {
    window.onbeforeunload = () => message;

    return () => {
      window.onbeforeunload = null;
    };
  }, [message]);
}
